// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/loader/loader.component.scss
// module id = 215
// module chunks = 0